import { useState, useEffect, useRef, RefObject } from 'react';

type UseImageLoadResult = Readonly<{
  imageLoaded: boolean;
  imageError: boolean;
  imageProps: {
    ref: RefObject<HTMLImageElement>;
    onLoad: () => void;
    onError: () => void;
  };
}>;

export const useImageLoad = (src: string | undefined): UseImageLoadResult => {
  const [imageLoaded, setImageLoaded] = useState(false);
  const [imageError, setImageError] = useState(false);
  const ref = useRef<HTMLImageElement>(null);

  useEffect(() => {
    setImageLoaded(false);
    setImageError(false);
    // Catch images already complete before onLoad attaches (cache / bundled assets)
    if (ref.current?.complete && ref.current.naturalWidth > 0) {
      setImageLoaded(true);
    }
  }, [src]);

  return {
    imageLoaded,
    imageError,
    imageProps: {
      ref,
      onLoad: () => setImageLoaded(true),
      onError: () => setImageError(true),
    },
  };
};
